import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { updateApplications } from "../../../../state/slices/application";
import { useUpdateApplicationMutation } from "../../../../state/services/applications";

// This component will be rendered when a text cell is double clicked on so the user can edit
// the text. It is a box larger than the cell default size. It also takes care of saving the
// edits by dispatching actions (redux store).
const LongTextCellEditor = forwardRef((props, ref) => {
  const { rows, cols, maxLength } = props;
  const [row] = useState(props.data);
  const [col] = useState(props.column.colId);
  const [value, setValue] = useState(props.value ? props.value : "");
  const refInput = useRef(null);
  const dispatch = useDispatch();
  const [updateApplication] = useUpdateApplicationMutation();

  useEffect(() => {
    // focus on the input
    setTimeout(() => refInput.current.focus());
  }, []);

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return value;
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if Enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        const newData = { ...row, [col]: value };
        updateApplication(newData);
        dispatch(updateApplications(newData));
        return true; // stop Ag-Grid from modifying the immutable data!
      },

      isPopup() {
        return true;
      },
    };
  });

  return (
    <div style={{ padding: "10px" }}>
      <textarea
        ref={refInput}
        value={value}
        cols={cols}
        rows={rows}
        // maxLength={maxlength}
        onChange={(event) => setValue(event.target.value)}
      />
    </div>
  );
});

export default LongTextCellEditor;
